<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="auditForm" :refresh-key="refreshKey" :show-expand="showExpand" :set-api-data="setApiData">
        <template v-slot:tabs>
            <v-row>
                <v-col>
                    <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                        <v-btn @click="toggleClosed(false)"> Outstanding </v-btn>
                        <v-btn @click="toggleClosed(true)"> Closed </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </template>
        <template v-slot:buttons="{ item }">
            <v-btn v-if="hasRole('Auditor')" color="tertiary" dark class="mr-2 float-right" @click="goToRecordsPage(item)">Resume</v-btn>
            <v-btn color="tertiary" dark class="mr-2" @click="goToCARs(item)">CARS</v-btn>
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'showExpand'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                auditForm: () => import('../forms/AuditForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Auditor', value: 'auditorId', table: 'auditors', form: () => import('../forms/AuditorForm') },
                    { text: 'Started On', value: 'startedOn', format: this.formatDate },
                    { text: 'Onsite Completed On', value: 'onsiteCompletedOn', format: this.formatDate },
                    { text: 'Closed On', value: 'closedOn', format: this.formatDate },
                    { text: 'Report File', value: 'reportFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    auditors: [],
                    members: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "memberId", direction: "ascending" },
                    { column: "auditorId", direction: "ascending" },
                    { column: "startedOn", direction: "descending" }
                ],
                itemsField: 'audits',
                editPageName: 'audit',
                apiMethod: 'Audits',
                claimName: 'Audits',
                formTitle: 'Audit',
                excelTitle: 'Audits',
                hasEditPage: true,

                displayClosed: false,
                refreshKey: 0,
            }
        },

        methods: {
            async goToRecordsPage(item) {
                this.$router.push({
                    name: 'auditEditor',
                    params: {
                        id: item.id
                    }
                });
            },

            async goToCARs(item) {
                var filter = {
                    memberId: item.memberId,
                    auditId: item.id
                }
                this.$router.push({
                    name: 'correctiveActionRequests',
                    query: { filter }
                })
            },

            async toggleClosed(displayClosed) {
                this.displayClosed = displayClosed;
                this.refreshKey += 1;
            },

            setApiData(data) {
                this.$set(this.apiData, 'auditors', data.auditors);
                this.$set(this.apiData, 'files', data.files);
                this.$set(this.apiData, 'members', data.members);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayClosed ? i.closedOn !== null : i.closedOn === null));
            }
        }
    };
</script>
